import { STATUS_META, type NextActionKey, type PeriodStatus, type StepKey } from '@btw/shared';
import type { MessageKey } from '../i18n';

/** KOR company (2026-10-30): no returns; its page shows the year's turnover against the € 20,000 limit. */
export const korHref = (entityId: string) => `/kor/${entityId}`;

/** The "Controleren en indienen" page of a company × quarter. `_step` is ignored (the old 6-step workplace is gone). */
export const periodHref = (entityId: string, quarter: string, _step?: StepKey) => `/aangiftes/${entityId}/${quarter}`;

/** Button label per status (§8.2) — the single source; never "Dien in bij de Belastingdienst". */
export const NEXT_ACTION_LABEL: Record<NextActionKey, MessageKey> = {
  upload_documents: 'next.upload_documents',
  answer_questions: 'next.answer_questions',
  view_concept: 'next.view_concept',
  busy: 'next.busy',
  view_differences: 'next.view_differences',
  compare_portal: 'next.compare_portal',
  upload_receipt: 'next.upload_receipt',
  view_return: 'next.view_return',
  refer: 'next.refer',
  view_kor: 'next.view_kor',
};

/**
 * Where a "next action" leads (2026-10): step 1 → Documenten, step 2 → Vragen, everything of step 3 → the
 * "Controleren en indienen" page, which picks its own sub-step from the status (journeyPosition in @btw/shared).
 */
export function nextActionHref(action: NextActionKey, entityId: string, quarter: string): string {
  if (action === 'upload_documents') return '/documenten?view=purchase';
  if (action === 'answer_questions') return '/vragen';
  if (action === 'view_kor') return korHref(entityId);
  return periodHref(entityId, quarter);
}

/** Overview ordering: overdue / blocked first, then the status urgency table (§5.3). */
export function urgencyScore(row: { status: PeriodStatus; overdueDays: number | null }): number {
  const overdue = row.overdueDays && row.overdueDays > 0 && row.status !== 'closed' && row.status !== 'filed' ? -10 : 0;
  return overdue + STATUS_META[row.status].urgency;
}
